import { ManageMultipleFilesModal } from "components/FileUpload/ManageMultipleFiles/ManageMultipleFilesModal";
import React from "react";
import { type UploadFilesConfig, uploadFilesToCoreApi } from "utilities/fileUploadUtils";
import { DeleteDialog } from "../../components";
import SegmentDetail from "../components/SegmentDetail";
import TrainJourneyDetail from "../components/TrainJourneyDetail";

interface Props {
  train: server.dto.LegacyTrain
  onTrainDetailEditClicked: () => void
  onSegmentEditClicked: (segment: server.dto.LegacyTrainSegment) => void
  onSegmentDeleted: (segment: server.dto.LegacyTrainSegment) => Promise<void>
  onTrainUpdated: (newTrain: server.dto.LegacyTrain) => void
}

const TrainJourneyDetailScreen = (props: Props) => {
  const [deletingSegment, setDeletingSegment] = React.useState<server.dto.LegacyTrainSegment>(undefined);
  const [displayFileUpload, setDisplayFileUpload] = React.useState(false);

  const uploadFiles = (files: File[], uploadConfig: UploadFilesConfig) => {
    return uploadFilesToCoreApi(
      window.CoreApi.File.UploadTrainFiles,
      window.CoreApi.File.UploadTrainFiles.absoluteUrl(),
      {
        files,
        trainId: props.train.id
      },
      uploadConfig
    );
  };

  const onFilesUploaded = async () => {
    const trainRes = await window.Api.Trains.GetTrain(props.train.id);
    props.onTrainUpdated(trainRes.data);
  };
  return <>
    <div className="flex-column gap-bigger">
      <div className="content-section">
        <TrainJourneyDetail
          train={props.train}
          onTrainDetailsEditClicked={props.onTrainDetailEditClicked}
          onFilesAddClick={() => { setDisplayFileUpload(true); }} />
      </div>
      <div className="list-with-gaps card-layout">
        <div className="list-with-gaps-body">
          {props.train.segments.map(seg => (
            <SegmentDetail
              key={seg.id}
              segment={seg}
              train={props.train}
              onEditClicked={props.onSegmentEditClicked}
              onDeleteClicked={setDeletingSegment}
            />
          ))}
        </div>
      </div>
    </div>

    <DeleteDialog
      isOpen={deletingSegment != null}
      message={RESX.GeneralWarnings.AreYouSure}
      handleClose={() => { setDeletingSegment(undefined); }}
      onDelete={async () => {
        props.onSegmentDeleted(deletingSegment);
        setDeletingSegment(undefined);
      }}
    />
    <ManageMultipleFilesModal
      isOpen={displayFileUpload}
      onClose={() => { setDisplayFileUpload(false); }}
      canEdit={props.train.permissions.canModify}
      files={props.train.files}
      onFilesChanged={onFilesUploaded}
      upload={uploadFiles}
      deleteEndpoint={window.CoreApi.File.DeleteTrainFile}
      renameEndpoint={window.CoreApi.File.SetTrainFileProperties}
    />
  </>;
};

export default TrainJourneyDetailScreen;